import { loadSwiper, observeOnce, prefersReducedMotion } from '@kame/lib';

class KameProductSlider extends HTMLElement {
  async connectedCallback() {
    const reduced = prefersReducedMotion();
    if (!reduced) {
      this.classList.add('is-armed');
      this.reveal = observeOnce(this, () => this.classList.add('is-inview'), '0px 0px -10% 0px');
    }

    if (this.dataset.url) {
      const loaded = await this.loadRecommendations();
      if (!loaded) return;
    }

    const container = this.querySelector('.swiper');
    if (!container) return;
    const Swiper = await loadSwiper(this.dataset.swiperSrc);
    if (!this.isConnected || this.swiper) return;

    this.progress = this.querySelector('[data-progress]');
    this.swiper = new Swiper(container, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      speed: reduced ? 0 : 400,
      watchOverflow: true,
      navigation: { prevEl: this.querySelector('[data-prev]'), nextEl: this.querySelector('[data-next]') },
      breakpoints: {
        750: { slidesPerView: 3, spaceBetween: 20 },
        1100: { slidesPerView: Number(this.dataset.columns) || 4, spaceBetween: 24 },
      },
      on: { init: this.paint, slideChange: this.paint, resize: this.paint },
    });
  }

  disconnectedCallback() {
    this.reveal?.disconnect();
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }

  async loadRecommendations() {
    const content = this.querySelector('[data-kame-ps-content]');
    if (!content) return false;
    try {
      const response = await fetch(this.dataset.url);
      if (!this.isConnected) return false;
      const html = await response.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kame-ps-content]');
      if (!fresh || !fresh.children.length) {
        this.remove();
        return false;
      }
      content.innerHTML = fresh.innerHTML;
      return true;
    } catch {
      this.remove();
      return false;
    }
  }

  paint = (swiper) => {
    const visible = Math.max(1, Math.floor(Number(swiper.params.slidesPerView) || 1));
    const ratio = swiper.isEnd ? 1 : Math.min(1, (swiper.activeIndex + visible) / swiper.slides.length);
    this.progress?.style.setProperty('--kame-progress', String(ratio));
  };
}

if (!customElements.get('kame-product-slider')) customElements.define('kame-product-slider', KameProductSlider);
